import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import HelpIcon from "@material-ui/icons/Help";
import { Divider } from "@material-ui/core";

function FormEntrepisoTanque(props) {
  const classes = useStyles();
  const { fields, handleInputChange } = props;
  const [reference, setReference] = React.useState("");


  return (
    <div>
      <div>
        <Typography className={classes.textPlanta}>
            Tanque reserva
        </Typography>
        <Divider/>
      </div>
      <Grid container spacing={5} className={classes.gridMain}>
        <Grid className={classes.gridSectionFields} item xs={6}>
          <Grid className={classes.gridLabelFirst} item xs={12}>
            <Typography className={classes.label}>
              <span className={classes.required}>*</span> Superficie entrepiso
              tanque de reserva (m2){" "}
            </Typography>
          </Grid>
          <Grid container spacing={3} className={classes.gridInputField}>
            <Grid className={classes.gridField} item xs={10}>
              <TextField
                placeholder="0.00 m2"
                fullWidth
                margin="none"
                className={classes.field}
                value={fields.inputs.superficieEntrepisoTanqueReserva}
                onChange={(e) => handleInputChange(e, "tanque")}
                name="superficieEntrepisoTanqueReserva"
                InputLabelProps={{
                  shrink: false,
                }}
                InputProps={{
                  required: true,
                  type: "number",
                  inputProps: {
                    step:"0.01",
                    min: 0,
                    max: 99999
                  },
                }}
                variant="outlined"
              />
            </Grid>

            <Grid className={classes.gridReference} item xs={2}>
              <HelpIcon
                onMouseOver={() => setReference("superficieEntrepisoTanqueReserva")}
                onMouseOut={() => setReference("")}
                className={classes.iconHelp}
              />
            </Grid>
          </Grid>

          <Grid className={classes.gridLabel} item xs={12}>
            <Typography className={classes.label}>
              <span className={classes.required}>*</span> Longitud paneles
              tanque de reserva (m){" "}
            </Typography>
          </Grid>
          <Grid container spacing={3} className={classes.gridInputField}>
            <Grid className={classes.gridField} item xs={10}>
              <TextField
                placeholder="0.00 m"
                fullWidth
                margin="none"
                className={classes.field}
                value={fields.inputs.longitudPanelesTanqueReserva}
                onChange={(e) => handleInputChange(e, "tanque")}
                name="longitudPanelesTanqueReserva"
                InputLabelProps={{
                  shrink: false,
                }}
                InputProps={{
                  required: true,
                  type: "number",
                  inputProps: {
                    step:"0.01",
                    min: 0,
                    max: 99999
                  },
                }}
                variant="outlined"
              />
            </Grid>

            <Grid className={classes.gridReference} item xs={2}>
              <HelpIcon
                onMouseOver={() => setReference("longitudPanelesTanqueReserva")}
                onMouseOut={() => setReference("")}
                className={classes.iconHelp}
              />
            </Grid>
          </Grid>

          <Grid className={classes.gridLabel} item xs={12}>
            <Typography className={classes.label}>
              <span className={classes.required}>*</span> Altura paneles tanque
              de reserva (m){" "}
            </Typography>
          </Grid>
          <Grid container spacing={3} className={classes.gridInputField}>
            <Grid className={classes.gridField} item xs={10}>
              <TextField
                placeholder="0.00 m"
                fullWidth
                margin="none"
                className={classes.field}
                value={fields.inputs.alturaPanelesTanqueReserva}
                onChange={(e) => handleInputChange(e, "tanque")}
                name="alturaPanelesTanqueReserva"
                InputLabelProps={{
                  shrink: false,
                }}
                InputProps={{
                  required: true,
                  type: "number",
                  inputProps: {
                    step:"0.01",
                    min: 0,
                    max: 99999
                  },
                }}
                variant="outlined"
              />
            </Grid>

            <Grid className={classes.gridReference} item xs={2}>
              <HelpIcon
                onMouseOver={() => setReference("alturaPanelesTanqueReserva")}
                onMouseOut={() => setReference("")}
                className={classes.iconHelp}
              />
            </Grid>
          </Grid>

          <Grid className={classes.gridLabel} item xs={12}>
            <Typography className={classes.label}>
              <span className={classes.required}>*</span> Capacidad tanque de
              reserva (l){" "}
            </Typography>
          </Grid>
          <Grid container spacing={3} className={classes.gridInputField}>
            <Grid className={classes.gridField} item xs={10}>
              <TextField
                placeholder="0.00 l"
                fullWidth
                margin="none"
                className={classes.field}
                value={fields.inputs.capacidadTanqueReserva}
                onChange={(e) => handleInputChange(e, "tanque")}
                name="capacidadTanqueReserva"
                InputLabelProps={{
                  shrink: false,
                }}
                InputProps={{
                  required: true,
                  type: "number",
                  inputProps: {
                    step:"0.01",
                    min: 0,
                    max: 99999
                  },
                }}
                variant="outlined"
              />
            </Grid>

            <Grid className={classes.gridReference} item xs={2}>
            </Grid>
          </Grid>

          <Grid className={classes.gridLabel} item xs={12}>
            <Typography className={classes.label}>
              Diámetro tanque de reserva (m){" "}
            </Typography>
          </Grid>
          <Grid container spacing={3} className={classes.gridInputField}>
            <Grid className={classes.gridField} item xs={10}>
              <TextField
                placeholder="0.00"
                fullWidth
                margin="none"
                className={classes.field}
                value={fields.inputs.diametroTanqueReserva}
                onChange={(e) => handleInputChange(e, "tanque")}
                name="diametroTanqueReserva"
                InputLabelProps={{
                  shrink: false,
                }}
                InputProps={{
                  required: false,
                  type: "number",
                  inputProps: {
                    step:"0.01",
                    min: 0,
                    max: 99999
                  },
                }}
                variant="outlined"
              />
            </Grid>

            <Grid className={classes.gridReference} item xs={2}>
              <HelpIcon
                onMouseOver={() => setReference("diametroTanqueReserva")}
                onMouseOut={() => setReference("")}
                className={classes.iconHelp}
              />
            </Grid>
          </Grid>
          
          <Grid className={classes.gridLabel} item xs={12}>
            <Typography className={classes.label}>Luz de Entrepiso
                  Tanque (m)
            </Typography>
          </Grid>
          <Grid container spacing={3} className={classes.gridInputField}>
            <Grid className={classes.gridField} item xs={10}>
              <TextField
                placeholder="0.00m"
                fullWidth
                margin="none"
                className={classes.field}
                value={fields.entrepisoTanque.luzEntrepisoTanque}
                onChange={(e) => handleInputChange(e, "tanque")}
                name="luzEntrepisoTanque"
                InputLabelProps={{
                  shrink: false,
                }}
                InputProps={{
                  required: false,
                  type: "number",
                  inputProps: {
                    step:"0.01",
                    min: 0,
                    max: 7,
                  },
                }}
                variant="outlined"
              />
            </Grid>

            <Grid className={classes.gridReference} item xs={2}>
              <HelpIcon
                onMouseOver={() => setReference("luzEntrepisoTanque")}
                onMouseOut={() => setReference("")}
                className={classes.iconHelp}
              />
            </Grid>
          </Grid>

        </Grid>
        <Grid className={classes.gridSectionImages} item xs={6}>
        <div className={classes.imageReference}>
            <div className={classes.imgSup}>
              {reference === "superficieEntrepisoTanqueReserva" ? (
                <img
                  width="100%"
                  height="auto"
                  src={require("../../../assets/images/steel-frame/superficieEntrepisoTanqueReserva.jpg")}
                  alt="Superficie Entrepiso Tanque Reserva"
                />
              ) : (
                ""
              )}
            </div>
            <div className={classes.imgLongPanel}>
              {reference === "longitudPanelesTanqueReserva" ? (
                <img
                  width="100%"
                  height="auto"
                  src={require("../../../assets/images/steel-frame/longitudPanelesTanqueReserva.jpg")}
                  alt="Longitud Paneles Tanque Reserva"
                />
              ) : (
                ""
              )}
            </div>
            <div className={classes.imgAltPanel}>
              {reference === "alturaPanelesTanqueReserva" ? (
                <img
                  width="100%"
                  height="auto"
                  src={require("../../../assets/images/steel-frame/alturaPanelesTanqueReserva.jpg")}
                  alt="Altura Paneles Tanque Reserva"
                />
              ) : (
                ""
              )}
            </div>
            <div className={classes.imgCap}>
              {reference === "capacidadTanqueReserva" ? (
                <img
                  width="100%"
                  height="auto"
                  src={require("../../../assets/images/deck/largo_deck.jpg")}
                  alt="Capacidad Tanque Reserva"
                />
              ) : (
                ""
              )}
            </div>
            <div className={classes.imgDia}>
              {reference === "diametroTanqueReserva" ? (
                <img
                  width="100%"
                  height="auto"
                  src={require("../../../assets/images/steel-frame/diametroTanqueReserva.jpg")}
                  alt="Diametro Tanque Reserva"
                />
              ) : (
                ""
              )}
            </div>
            <div className={classes.imgLuzEntrepisoTanque}>
              {reference === "luzEntrepisoTanque" ? (
                <img
                  width="100%"
                  height="auto"
                  src={require("../../../assets/images/steel-frame/luzEntrepisoTanque.jpg")}
                  alt="Luz Entrepiso Tanque"
                />
              ) : (
                ""
              )}
            </div>
            
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default FormEntrepisoTanque;

const useStyles = makeStyles((theme) => ({
  label: {
    fontSize: "18px",
    fontWeight: "400",
    color: "black",
    paddingBottom: 10,
  },
  required: {
    color: "red",
  },
  field: {
    paddingTop: 6,
  },
  iconHelp: {
    color: "#5B6670",
    marginTop: 20,
  },
  gridMain: {
    paddingTop: 20,
    paddingBottom: 20,
  },
  gridInputField: {
    paddingBottom: 5,
  },
  gridLabel: {
    paddingTop: 20,
  },
  gridSectionImages: {
    padding: 20,
  },
  imageReference: {
    textAlign: "center",
  },
  imgSup: {
    position: "relative",
    paddingTop: 10,
  },
  imgLongPanel: {
    position: "relative",
    paddingTop: 20,
  },
  imgAltPanel: {
    position: "relative",
    paddingTop: 30,
  },
  imgCap: {
    position: "relative",
    paddingTop: 35,
  },
  imgDia: {
    position: "relative",
    paddingTop: 35,
  },
  imgLuzEntrepisoTanque: {
    position: "relative",
    paddingTop: 45,
  },  
  iconEdit: {
    color: "#2b323c",
    marginTop: 2,
  },
  textEdit:{
    color: "#2b323c",
    fontSize: "16px",
    fontWeight: "bold",
  },
  textPlanta:{
    color: "#2b323c",
    fontSize: "22px",
    fontWeight: "bold",
  },
  
}));
